import { useCheckRelations } from "components/common";
import { AuthEnums } from "models/enums";

function useDocumentPermissions() {
  const { hasRelation } = useCheckRelations();
  const hasDocumentPermissions = hasRelation(AuthEnums.PersonCompanyRelationType.Documents);

  return {
    hasDocumentPermissions,
  };
}

export default useDocumentPermissions;
